export enum TagsSortOrder {
	ByFrequency = 'TAGS_SORT_BY_FREQUENCY',
	Alphabetically = 'TAGS_SORT_ALPHABETICALLY'
}
